
  import { controls } from "../controls";
  
  
  const maritalstatusearch = {
    label: "Marital Status Search",
    pageLabel: "Marital Status  Search",
    starting: true,
    url: "maritalstatusearch",
    pageType: "history",
    formState: { checked: "view" },
    formActions: { edit: { allow: true }, delete: { allow: true } },
    // "Address.",
    filter:[       
    ...controls.displayText({tab:"filter",label: "Name",width:"col-sm-2"}),
    ...controls.text({tab: "filter",name:"name"})
    ],
    form:[],
    history: {
        perPage: 10,
        reportHeader: "Marital Status",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        displayColumns: [
          {
            Header: "Code",
            accessor: "code",
            width: 150
          },
          {
            Header: "Name",
            accessor: "description",
          },
          {
            Header: "guid",
            show:false,
            accessor: "guid",
          }
        ]
      }
  }

  export default maritalstatusearch;